import { render } from "./Movements.vue?vue&type=template&id=c3748de8"
import script from "./Movements.vue?vue&type=script&lang=js"
export * from "./Movements.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__